import React, { Component } from 'react';
import { Modal, Button, Input, message } from 'antd';
import { Link } from 'react-router-dom';
import Wrapper from './style';
import {
	EXCHANGE_CARD_ICON_BLACK,
	XHT_ICON,
	XHT_ICON_LIGHT,
	SUCCESS_COLLATERAL_VIEDO
} from '../../config/media';
import { COLLATERAL_TOTAL_AMOUNT } from '../../config/constants';
import { pledgeXht } from '../../common/fetch';

class Collateralize extends Component {
	state = {
		check: false,
		step: 1,
		is_public: this.props.collateral.is_public,
		amount: '',
		error: false,
		isConfirmed: false
	};

	handleCheck = () => {
		this.setState({ check: !this.state.check });
	};

	collateralize = () => {
		const { amount } = this.state;
		if (amount === '' || isNaN(parseFloat(amount))) {
			return;
		}
		const step = parseFloat(COLLATERAL_TOTAL_AMOUNT) === parseFloat(amount) ? 2 : 3;
		this.setState({ step });
	};

	handleSubmit = async () => {
		const { collateral, onCollateralCallback = () => {} } = this.props;
		const { amount } = this.state;
		if (amount === '' || isNaN(parseFloat(amount))) return;
		const body = {
			exchange_id: collateral.id,
			amount: parseFloat(amount)
		};
		try {
			await pledgeXht(body);
			onCollateralCallback(collateral.id);
			this.setState({ step: 5 });
		} catch (error) {
			console.error(error);
			message.error(error.data.message);
		}
	};

	setMax = () => {
		const { user } = this.props;
		const amount =
			user.balance.xht_available >= COLLATERAL_TOTAL_AMOUNT
				? COLLATERAL_TOTAL_AMOUNT
				: user.balance.xht_available;
		const error = parseFloat(amount) <= 0
			? 'Amount is not enough'
			: false;
		this.setState({
			amount,
			error
		});
	};

	handleChange = (e) => {
		const { user } = this.props;
		const { name, value } = e.target;
		if (value === '-') {
			return;
		}
		this.setState({ [name]: value }, () => {
			if (isNaN(parseFloat(value)) || parseFloat(value) <= 0) {
				this.setState({ error: 'Please input an amount' });
			} else if (parseFloat(value) > user.balance.xht_available) {
				this.setState({ error: 'Amount is not enough' });
			} else {
				this.setState({ error: false });
			}
		});
	};

	handleSwitch = (bool) => {
		this.setState({ is_public: bool });
	};

	onCancel = () => {
		this.setState(
			{ check: false, amount: '', error: false, visible: false, step: 1 },
			this.props.onCancel
		);
	};

	handleInput = (e) => {
		if (e.target.value === "I UNDERSTAND") {
			this.setState({ isConfirmed: true })
		} else {
			this.setState({ isConfirmed: false })
		}
	}

	setAmount = () => {
		const { user } = this.props;
		this.setState({ amount: user.balance.xht_available })
	};

	renderPopup = () => {
		const { user, collateral } = this.props;
		const { error, isConfirmed, amount, step } = this.state;
		const uid = (collateral.id % 6) + 1;

		switch (step) {
			case 2:
				return <Wrapper>
					<div className="info-box step2">
						<h2>
							Amount of XHT to stake
						</h2>
						<div className="d-flex">
							<b>Your XHT Balance:</b>
							<img src={XHT_ICON} className="xht-icon" alt="XHT"/>
							<span className="anchor" onClick={this.setAmount}>
								{user.balance.xht_available}
							</span>
						</div>
						<div className="collater-info">
							<div className="inner-content">
								<img
									src={EXCHANGE_CARD_ICON_BLACK[uid]}
									alt="EXCHANGE_CARD_ICON_BLACK"
								/>
								<p>
									<b>{collateral.display_name}</b>
								</p>
							</div>
							<div className="stat-info">
								<p className="no-exchange">
									<b>XHT amount to stake</b>
									<br />
									<div className="input-container">	
										<Input
											name="amount"
											value={amount}
											onChange={this.handleChange}
											placeholder="Amount"
											addonBefore={
												<img
													style={{ width: '24px' }}
													src={XHT_ICON_LIGHT}
													alt="xht-icon"
												/>
											}
											addonAfter={
												<span className="max" onClick={this.setMax}>
													MAX
												</span>
											}
										/>
										<p className="error red">{error}</p>
									</div>
								</p>
							</div>
						</div>
						<div className="btn-wrapper">
							<Button
								block
								type="primary"
								onClick={() => this.setState({ step: 1 })}
							>
								Back
							</Button>
							<Button
								block
								type="primary"
								disabled={this.state.amount === "" || error}
								onClick={this.collateralize}
							>
								Proceed
							</Button>
						</div>
					</div>
				</Wrapper>
			case 3:
				return <Wrapper>
					<div className="step3-container">
						<h2>
							Check & confirm
						</h2>
						<div>
							Check the details of XHT stake removal.
						</div>
						<div className='box-container'>
							<div className='box-title'>Stake details</div>
							<div className='flex-container'>
								<img
									src={EXCHANGE_CARD_ICON_BLACK[uid]}
									alt="EXCHANGE_CARD_ICON_BLACK"
								/>
								<div>
									<b>Project:</b>{' '}
									<span>{collateral.display_name}</span>
								</div>
								<div>
									<b>Amount to stake:</b>{' '}
									<span>{amount}</span>
								</div>
								<div>
									<b>Removal process:</b>{' '}
									<span>2,102,400 Ethereum blocks (~1 year)</span>
								</div>
							</div>
						</div>
						<div className="btn-wrapper">
							<Button
								block
								type="primary"
								onClick={() => this.setState({ step: 2 })}
							>
								Back
							</Button>
							<Button
								block
								type="primary"
								onClick={() => this.setState({ step: 4 })}
							>
								Proceed
							</Button>
						</div>
					</div>
				</Wrapper>
			case 4:
				return <Wrapper>
					<div className="insufficient-header">
						<h2>Are you sure?</h2>
						<p>
							Please acknowledge that you understand that removing XHT
							stake is roughly a one year process during which all earnings will halt.
						</p>
					</div>

					<div className="step4-content">
						<b>Type 'I UNDERSTAND' to confirm</b>
						<Input onChange={this.handleInput}/>
						<div className="btn-wrapper">
							<Button
								block
								type="primary"
								onClick={() => this.setState({ step: 3 })}
							>
								Back
							</Button>
							<Button
								block
								type="primary"
								disabled={!isConfirmed}
								onClick={isConfirmed ? this.handleSubmit : null}
							>
								Add XHT stake
							</Button>
						</div>
					</div>
				</Wrapper>
			case 5:
				return <Wrapper>
					<div className="success-image">
						<video autoPlay loop>
							<source src={SUCCESS_COLLATERAL_VIEDO} type="video/mp4" />
						</video>
					</div>

					<div className="info-box">
						<div className="collater-info">
							<div className="img-wrapper">
								<img
									src={EXCHANGE_CARD_ICON_BLACK[uid]}
									alt="EXCHANGE_CARD_ICON_BLACK"
								/>
							</div>
							<div className="stat-info">
								<div className="small-txt">
									<b>Project:</b>{' '}{collateral.display_name}
									<div>
										<b>XHT staked:</b>{' '}
										<img src={XHT_ICON_LIGHT} alt="xth" className="xht-icon" />{' '}
										<span>{collateral.pledges.mine}</span>
									</div>
									<Link to="/wallet?type=2">View staking details</Link>
								</div>
							</div>
						</div>

						<p className="footer">
							You will now earn a regular stream of XHT from all trading fees the network earns and
							newly minted tokens. You can start the 1 year removal process at anytime.
						</p>
						<Button
							block
							type="primary"
							disabled={error}
							onClick={this.onCancel}
						>
							Close
						</Button>
					</div>
				</Wrapper>
			case 1:
			default:
				return <Wrapper>
					<div className="collateral-header">
						<img src={XHT_ICON} alt="xth" />
						<h2>
							Staking XHT Collateral
						</h2>
						<p>
							Staking XHT as collateral on exchanges can earn you network fees
							from all projects within the HollaEx network. You will also earn certain
							amount of newly minted XHT tokens.
						</p>
						<p>
							Staking on projects is a long term endeavor. Removing XHT staked on
							any project is a year long process and will halt all earnings.
						</p>
					</div>

					<div className="info-box">
						<div className="collater-info">
							<div>
								<img
									src={EXCHANGE_CARD_ICON_BLACK[uid]}
									alt="EXCHANGE_CARD_ICON_BLACK"
								/>
								<p>
									<b>{collateral.display_name}</b>
								</p>
							</div>
							<div className="stat-info">
								<p className="no-exchange">
									<b>Earning streams:</b>
									<br />
									1. Network trade fees
									<br />
									2. Newly minted XHT tokens
								</p>
								<p className="large-txt">
									<b>Removal process:</b>{' '}
									<span>1 year</span>
								</p>
							</div>
						</div>
						<div className="btn-wrapper">
							<Button
								block
								type="primary"
								onClick={this.onCancel}
							>
								Back
							</Button>
							<Button
								block
								type="primary"
								disabled={error}
								onClick={() => this.setState({ step: 2 })}
							>
								I understand. Proceed.
							</Button>
						</div>
					</div>
				</Wrapper>
			}
	}

	render() {
		const { visible, onOk } = this.props;
		const { step } = this.state;

		return (
			<Modal
				visible={visible}
				footer={null}
				onOk={onOk}
				onCancel={this.onCancel}
				bodyStyle={{ padding: 0 }}
				width={step === 2 || step === 3 || step === 5 ? 450 : 550}
			>
				{this.renderPopup()}
			</Modal>
		);
	}
}

export default Collateralize;
